<div class="cfa-toolbar cfa-toolbar-height" [class.dropShadow]="showDropShadow"
  [class.mat-app-background]="useMaterialTheme" [class.cfaCustomLightTheme]="!useMaterialTheme">
  <div class="container cfa-toolbar-height" [class.noMaxWidth]="ignoreContainerPadding">
    <div class="row cfa-nowrap-row cfa-toolbar-height justify-content-start justify-content-lg-between">
      <div class="col-auto pr-0 pl-0 align-self-center text-center">
        @if (windowIsLarge) {
          <cfa-app-brand-button toolbarLeft-Desktop [appName]="appName" (click)="clickHome()"
          id="home-button"></cfa-app-brand-button>
        }
        @if (!windowIsLarge) {
          @if (!showHamburgerMenu) {
            <cfa-app-brand-button toolbarLeft-Mobile (click)="clickHome()"
            id="home-button"></cfa-app-brand-button>
          }
          @if (showHamburgerMenu) {
            <cfa-button [icon]="'Menu'"
              (click)="cfaTabs.length === 0 ? clickMenu() : clickHamburger()" id="hamburger-button"
            ></cfa-button>
          }
        }
      </div>
      @if (!customHeader) {
        <div class="col offset-1 cfa-toolbar-height align-self-center d-none d-lg-block">
          @if (cfaTabs.length > 0) {
            <cfa-toolbar-tab-container [cfaTabs]="cfaTabs"
              [useMaterialTheme]="useMaterialTheme">
            </cfa-toolbar-tab-container>
          }
        </div>
      }
      @if (customHeader) {
        <div class="col-auto col-lg cfa-nav-header-wrapper align-self-center" [class.hidden]="searchReady"
          [class.mat-app-background]="useMaterialTheme"
          [class.cfaCustomLightTheme]="!useMaterialTheme">
          <ng-content select="cfa-nav-header"></ng-content>
        </div>
      }
      <div class="col col-lg-auto align-self-center pl-0 pr-0" [class.order4]="!cartEnabled">
        <div class="row cfa-nowrap-row d-flex d-lg-none">
          <div class="col text-center">
            <span class="cfa-18">
              <b>{{mobileTitle}}</b>
            </span>
          </div>
        </div>
        <div class="row cfa-nowrap-row d-none d-lg-flex">
          <div class="col text-right align-self-center cfa-11" [class.pr-0]="cfaMenuItems.length > 0">
            <!--                        <span style="font-size: 12px">{{userName}}</span>-->
            <!--                        <span class="clicky cfa-hover-primary" *ngIf="cfaMenuItems.length === 0"-->
          <!--                              (click)="clickSignOut()" id="signOut-button" style="margin-left: 5px; font-size: 12px">(sign out)</span>-->
          <emm-avatar
            [fullName]="userName"
            [isDarkMode]="false"
            [backgroundColor]="'#DD0031'"
            [textColor]="'#ffffff'"
            (signOut)="clickSignOut()"
          ></emm-avatar>
        </div>
        @if (cfaMenuItems.length > 0) {
          <div class="col-auto align-self-center pl-0 pr-0 clicky cfa-primary"
            (click)="clickMenu()" id="threeDotMenu-button">
            <svg-icon src="https://d4gii57lvoht3.cloudfront.net/images/Three_Dot_Vert.svg"
            class="cfa-desktop-menu-icon"></svg-icon>
          </div>
        }
      </div>
      @if (activeSearchObject) {
        <div class="row cfa-nowrap-row justify-content-center justify-content-lg-end cfa-primary"
          [class.clicky]="searchObjects.length > 1"
          (click)="searchObjects.length > 1 ? clickStore() : null" id="storeSelect-dropDown">
          <div class="col align-self-center text-center text-lg-right ellipse-overflow"
            [class.pr-0]="searchObjects.length > 1">
            <span class="cfa-14">
              {{activeSearchObject.id}} • {{activeSearchObject.description}}
            </span>
          </div>
          @if (searchObjects.length > 1) {
            <div class="col-auto align-self-center pl-0 pr-0">
              <svg-icon src="https://d4gii57lvoht3.cloudfront.net/images/Arrow_Down.svg"
              class="cfa-store-select-icon" [class.rotate]="searchReady"></svg-icon>
            </div>
          }
        </div>
      }
    </div>
    <div class="col-auto align-self-center text-center" [class.order3]="!cartEnabled">
      <ng-content select="[toolbarRight]"></ng-content>
    </div>
  </div>
</div>
</div>

@if (showHamburgerMenu && cfaTabs.length > 0) {
  <cfa-hamburger-menu [(expandHamburgerMenu)]="expandHamburgerMenu"
    [cfaTabs]="cfaTabs" [cfaMenuItems]="cfaMenuItems" [userName]="userName" [useMaterialTheme]="useMaterialTheme"
    (signOutClicked)="clickSignOut()" (homeClicked)="clickHome()" [elementToIgnoreClicks]="'hamburger-button'">
  </cfa-hamburger-menu>
}
